export default "__VITE_ASSET__CdVa4uwF__"